export type PartnerTheme = {
  name: string;
  paths: string[];
  ctaBgColor: string;
  ctaBgColorHover: string;
  ctaTextColor: string;
  logo?: {
    src: string;
    width: number;
    height: number;
    alt: string;
  };
};

export const partnerThemes: PartnerTheme[] = [
  {
    name: "felmo",
    paths: ["/partnership-felmo", "/partnerschaft-felmo"],
    ctaBgColor: "#118a49",
    ctaBgColorHover: "#0e7340",
    ctaTextColor: "#FFFFFF",
    logo: {
      src: "/images/partners/felmo_logo_primary_white.png",
      width: 80,
      height: 24,
      alt: "Lassie x Felmo",
    },
  },
];
